import { FileResource, resourcesList } from '@/utils/http'
import { notification, message as AntMessage } from 'ant-design-vue'
import $Bus from '@/pages/projectImpl/js/eventBus'

function indexOf(arr, key, value) {
  if (!Array.isArray(arr)) {
    return -1
  }
  for (let i = 0; i < arr.length; i++) {
    if (arr[i][key] === value) {
      return i
    }
  }
  return -1
}

const UPLOAD_FILE_SIZE = 4 // 最大同时上传文件数量
/*
 *
 * 文件上传状态 status：-1（上传失败），0（等待上传），1（正在上传），2（上传成功）
 *
 * */
export default {
  namespaced: true,
  state: {
    OSS: null,
    AliyunUpload: null,
    visible: false,
    uploadFileList: [],
    acsTime: null,
    vodTime: null,
    uploadInfo: {
      success: 0,
      running: 0,
      fail: 0,
    },
    paths: [],
    replaceFile: false, // 是否执行的是替换文件操作
    timer: null,
  },
  getters: {
    getOSS: (state) => () => {
      return state.OSS
    },
    getAliyunUpload: (state) => () => {
      return state.AliyunUpload
    },
    getUploadFileList: (state) => {
      return state.uploadFileList
    },
    getVisible: (state) => {
      return state.visible
    },
    getAcsTime: (state) => {
      return state.acsTime
    },
    getVodTime: (state) => {
      return state.vodTime
    },
    getUploadInfo: (state) => {
      return state.uploadInfo
    },
    getPaths: (state) => {
      return state.paths
    },
    getReplaceFile: (state) => {
      return state.replaceFile
    },
  },
  mutations: {
    setOSS(state, data) {
      state.OSS = data
    },
    setAliyunUpload(state, data) {
      state.AliyunUpload = data
    },
    setUploadFileList(state, data) {
      state.uploadInfo = {
        success: 0,
        running: 0,
        fail: 0,
      }
      for (let i = 0; i < data.length; i++) {
        if (data[i].status === -1) {
          state.uploadInfo.fail++
          continue
        }
        if (data[i].progress >= 100) {
          state.uploadInfo.success++
        } else {
          state.uploadInfo.running++
        }
      }

      state.uploadFileList = data
    },
    setVisible(state, data) {
      state.visible = data
    },
    setAcsTime(state, data) {
      state.acsTime = data
    },
    setVodTime(state, data) {
      state.vodTime = data
    },
    setPaths(state, data) {
      state.paths = data
    },
    setReplaceFile(state, data) {
      state.replaceFile = data
    },
  },
  actions: {
    async getAcs({ commit }) {
      const acs = await resourcesList.GetAcsResponse()
      commit('setAcsTime', Date.now())
      commit(
        'setOSS',
        new OSS({
          region: 'oss-cn-hangzhou', //根据那你的Bucket地点来填写
          accessKeyId: acs.data.accessKeyId, //自己账户的accessKeyId
          accessKeySecret: acs.data.accessKeySecret, //自己账户的accessKeySecret
          bucket: process.env.VUE_APP_ENVIRONMENT === 'preview' ? 'iquizoo-storage' : 'iquizoo', //bucket名字
          stsToken: acs.data.securityToken,
        })
      )
      return acs
    },
    async getVod({ commit, getters, dispatch }, fileName) {
      /*if (Date.now() - getters["getVodTime"] < 1000 * 60 * 30 && getters["getAliyunUpload"]()) {
                return getters["getAliyunUpload"]() || {}
            }*/
      const Params = {
        parentId: process.env.VUE_APP_ENVIRONMENT === 'uat' ? 1000482188 : process.env.VUE_APP_ENVIRONMENT === 'preview' ? 1000482194 : 1000482193,
        fileName: fileName,
        title: fileName.substring(fileName.lastIndexOf('.'), 0),
      }
      const vod = await resourcesList.CreateUploadVideo(Params)
      commit('setAliyunUpload', vod.data)
      commit('setVodTime', Date.now())
      return vod.data
    },
    async file({ commit, getters, dispatch }, file) {
      if (Object.prototype.toString.call(file) !== '[object File]') {
        return
      }
      const paramsType = file._paramsType
      delete file._paramsType
      const suffix = file.name.substring(file.name.lastIndexOf('.'))
      const randomStr = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      const key =
        Date.now() +
        Array.from({ length: 8 })
          .map(() => randomStr[parseInt(Math.random() * randomStr.length)])
          .join('') +
        suffix
      let path = 'fat/resource_centre/' + key
      if (process.env.VUE_APP_ENVIRONMENT === 'uat') {
        path = 'uat/resource_centre/' + key
      }
      if (process.env.VUE_APP_ENVIRONMENT === 'preview') {
        // 2024-01-11 黄总：正式环境不要[pro/]
        path = 'resource_centre/' + key
      }

      const fileOption = {
        name: file.name,
        fileSize: file.size,
        size: (file.size / (1024 * 1024)).toFixed(2) + 'M',
        progress: 0,
        uploadName: path,
        uploadId: '',
        status: 1,
      }
      commit(
        'setUploadFileList',
        getters['getUploadFileList'].map((m) => {
          if (m.name === fileOption.name && m.fileSize === fileOption.fileSize) {
            return fileOption
          }
          return m
        })
      )
      if (Date.now() - getters['getAcsTime'] > 1000 * 60 * 30) {
        await dispatch('getAcs')
      }
      getters['getOSS']()
        .multipartUpload(path, file, {
          progress: (progress, data) => {
            if (!getters['getUploadFileList'].length) {
              $Bus.$emit('ReplaceFile', {
                ...fileOption,
                progress: Math.floor(progress * 100),
              })
              return
            }
            if (!data) {
              commit(
                'setUploadFileList',
                getters['getUploadFileList'].map((m) => {
                  if (m.uploadName === fileOption.uploadName && m.fileSize === fileOption.fileSize) {
                    m.uploadId = fileOption.uploadName
                    m.progress = Math.floor(progress * 100)
                    m.status = progress >= 1 ? 2 : 1
                  }
                  return m
                })
              )
              return
            }
            commit(
              'setUploadFileList',
              getters['getUploadFileList'].map((m) => {
                if (m.uploadName === data.name && m.fileSize === data.file.size) {
                  m.uploadId = data.uploadId
                  m.progress = Math.floor(progress * 100)
                  m.status = progress >= 1 ? 2 : 1
                }
                return m
              })
            )
          },
        })
        .then((res) => {
          console.log(res)
          dispatch('addFile', {
            file: file,
            uri: res.name,
            uploadName: fileOption.uploadName,
            fileSize: fileOption.fileSize,
            type: paramsType,
          })
        })
        .catch((err) => {
          if (!getters['getUploadFileList'].length) {
            $Bus.$emit('ReplaceFile', {
              ...fileOption,
              status: -1,
            })
            return
          }
          commit(
            'setUploadFileList',
            getters['getUploadFileList'].map((m) => {
              if (m.uploadName === fileOption.uploadName) {
                m.status = -1
              }
              return m
            })
          )
          console.error(err)
        })
    },
    async video({ commit, getters, dispatch }, file) {
      const paramsType = file._paramsType
      delete file._paramsType
      const vod = await dispatch('getVod', file.name)
      console.log(vod)
      const uploader = new AliyunUpload.Vod({
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: 'cn-shanghai',
        userId: '1303984639806000',
        // 添加文件成功
        addFileSuccess: function (uploadInfo) {
          console.log('添加文件成功: ', uploadInfo)
          const fileOption = {
            type: 'video',
            name: uploadInfo.file.name,
            fileSize: uploadInfo.file.size,
            size: (uploadInfo.file.size / (1024 * 1024)).toFixed(2) + 'M',
            progress: 0,
            uploadId: uploadInfo.ri,
            videoId: vod.videoId,
            uploader,
            status: 1,
          }
          commit(
            'setUploadFileList',
            getters['getUploadFileList'].map((m) => {
              if (m.name === fileOption.name && m.fileSize === fileOption.fileSize) {
                return fileOption
              }
              return m
            })
          )
        },
        // 开始上传
        onUploadstarted: function (uploadInfo) {
          console.log('文件开始上传:' + uploadInfo.file.name)
          uploader.setUploadAuthAndAddress(uploadInfo, vod.uploadAuth, vod.uploadAddress, vod.videoId)
        },
        // 文件上传成功
        onUploadSucceed: (uploadInfo) => {
          console.log('文件上传成功: ', uploadInfo)
          dispatch('addFile', {
            file: uploadInfo.file,
            uri: uploadInfo.videoId,
            uploadName: uploadInfo.file.name,
            fileSize: uploadInfo.file.size,
            type: paramsType,
          })
        },
        // 文件上传失败
        onUploadFailed: function (uploadInfo, code, message) {
          console.log('文件上传失败', uploadInfo)
          commit(
            'setUploadFileList',
            getters['getUploadFileList'].map((m) => {
              if (m.uploadId === uploadInfo.ri) {
                m.status = -1
              }
              return m
            })
          )
          const form = new FormData()
          form.append('videoId', uploadInfo.videoId)
          FileResource.deleteVideo(form)
        },
        // 取消文件上传
        onUploadCanceled: function (uploadInfo, code, message) {
          /*const arr = getters["getUploadFileList"];
                    arr.shift();
                    commit("setUploadFileList", arr);*/
          console.log('视频上传取消', uploadInfo)
          const form = new FormData()
          form.append('videoId', uploadInfo.videoId)
          FileResource.deleteVideo(form)
        },
        // 文件上传进度
        onUploadProgress: function (uploadInfo, totalSize, progress) {
          // console.log("文件上传进度", uploadInfo, totalSize, progress);
          if (indexOf(getters['getUploadFileList'], 'uploadId', uploadInfo.ri) === -1) {
            const fileOption = {
              type: 'video',
              name: uploadInfo.file.name,
              fileSize: uploadInfo.file.size,
              size: (uploadInfo.file.size / (1024 * 1024)).toFixed(2) + 'M',
              progress: Math.floor(progress * 100),
              status: progress >= 1 ? 2 : 1,
              uploadId: uploadInfo.ri,
              videoId: vod.videoId,
              uploader,
            }
            if (!getters['getUploadFileList'].length) {
              $Bus.$emit('ReplaceFile', fileOption)
              return
            }
            commit(
              'setUploadFileList',
              getters['getUploadFileList'].map((m) => {
                if (m.name === fileOption.name && m.fileSize === fileOption.fileSize && m.uploadId === fileOption.uploadId) {
                  return fileOption
                }
                return m
              })
            )
            return
          }
          commit(
            'setUploadFileList',
            getters['getUploadFileList'].map((m) => {
              if (m.uploadId === uploadInfo.ri) {
                m.progress = Math.floor(progress * 100)
                m.status = progress >= 1 ? 2 : 1
              }
              return m
            })
          )
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          console.log('上传凭证超时', uploadInfo)
          resourcesList.RefreshUploadVideo('?videoId=' + uploadInfo.videoId).then((res) => {
            let uploadAuth = res.data.uploadAuth
            getters['getAliyunUpload'].resumeUploadWithAuth(uploadAuth)
          })
        },
        // 全部文件上传结束
        onUploadEnd: function (uploadInfo) {
          console.log('全部文件上传结束', uploadInfo)
        },
      })
      uploader.addFile(file, null, null, null, '{"Vod":{}}')
      console.log(uploader.startUpload)
      uploader.startUpload()
    },
    addFile({ commit, getters, dispatch, state }, data) {
      console.log(data)
      const fileType = [
        ['pdf', 'doc', 'docx', 'xls', 'xlsx', 'ppt', 'pptx'],
        ['jpg', 'jpeg', 'png', 'bmp', 'gif'],
        ['mp3', 'wav', 'wma'],
        ['mp4', 'flv', 'avi', 'mkv', 'mov', 'wmv'],
        ['rar', 'zip', '7z'],
      ]
      let duration = '',
        fileTypeValue = undefined
      for (let i = 0; i < fileType.length; i++) {
        if (fileType[i].indexOf(data.file.name.substring(data.file.name.lastIndexOf('.') + 1).toLowerCase()) > -1) {
          fileTypeValue = i + 1
          break
        }
      }
      new Promise((resolve, reject) => {
        if (![3, 4].includes(fileTypeValue)) {
          resolve()
          return
        }
        const blob = new Blob([data.file])
        const video = document.createElement('video') // 创建一个视频元素，用于接收读取到的文件内容
        video.preload = 'metadata'
        video.src = URL.createObjectURL(blob)
        video.onloadedmetadata = () => {
          // 视频元数据加载成功
          // video.duration 返回浮点数，表示媒体文件的时间长度（单位秒）
          console.log('视频时长', video.duration) // 视频时长
          duration = Math.floor(video.duration)
          resolve()
        }
        video.onerror = () => {
          // 视频元数据加载失败
          console.log('视频加载失败')
          reject()
        }
      }).finally(() => {
        console.log(duration)
        const obj = getters['getPaths'].map((m) => m.name).join('/')
        const filePath = data.file.webkitRelativePath.substring(data.file.webkitRelativePath.lastIndexOf('/'), 0)
        const params = {
          type: data.type,
          path: obj ? obj + (filePath ? '/' + filePath : '') : filePath || undefined,
          fileItem: {
            name: data.file.name.substring(data.file.name.lastIndexOf('.'), 0),
            fileName: data.file.name,
            size: data.file.size,
            uri: data.uri.split('?')[0],
            estimatedTime: duration,
            fileType: fileTypeValue,
            type: data.type,
          },
        }
        if (!getters['getReplaceFile']) {
          FileResource.add(params)
            .then((res) => {
              if (!res.isSuccess) {
                if (data.retryNumber !== 1) {
                  setTimeout(() => {
                    dispatch('addFile', { ...data, retryNumber: 1 })
                  }, 500)
                } else {
                  commit(
                    'setUploadFileList',
                    getters['getUploadFileList'].map((m) => {
                      if (m.uploadName === data.uploadName && m.fileSize === data.fileSize) {
                        m.progress = 0
                        m.status = -1
                      }
                      return m
                    })
                  )
                  AntMessage.error(res.message)
                }
              }

              setTimeout(() => {
                dispatch('startUpload')
              }, 500)
            })
            .finally(() => {
              clearTimeout(state.timer)
              state.timer = setTimeout(() => {
                if (state.uploadInfo.running === 0) {
                  if (!state.replaceFile) {
                    if (!state.visible) {
                      notification.success({
                        message: '文件全部上传完成',
                      })
                    }
                    console.log('文件全部上传完成')
                    $Bus.$emit('RefreshResourcesList')
                  }
                  state.visible = false
                  state.uploadFileList = []
                }
              }, 1000)
            })
        } else {
          $Bus.$emit('ReplaceFile', { type: 'add', data: params.fileItem })
        }
      })
    },
    // 添加上传文件
    uploadFile({ commit, getters, dispatch }, data) {
      const fileOption = {
        file: data.file,
        type: data.type,
        paramsType: data.paramsType,
        name: data.file.name,
        fileSize: data.file.size,
        size: (data.file.size / (1024 * 1024)).toFixed(2) + 'M',
        progress: 0,
        status: 0,
      }
      commit('setUploadFileList', [fileOption, ...getters['getUploadFileList']])
      dispatch('startUpload')
      commit('setVisible', true)
    },

    // 开始文件上传（支持同时上传5个资源，超出资源显示为“待上传”状态进行排队）
    startUpload({ getters, dispatch }) {
      console.log('%c执行文件上传任务队列', 'color: red')
      const FileList = getters['getUploadFileList']
      let uploadingQuantity = 0 // 正在上传数量
      let waitingFile = null // 等待上传文件

      for (let i = 0; i < FileList.length; i++) {
        if (FileList[i].status === 1) {
          uploadingQuantity++
        }
        if (FileList[i].status === 0 && !waitingFile) {
          waitingFile = FileList[i]
        }
      }
      if (uploadingQuantity < UPLOAD_FILE_SIZE && waitingFile) {
        waitingFile.status = 1
        waitingFile.file._paramsType = waitingFile.paramsType ? waitingFile.paramsType : 0
        dispatch(waitingFile.type === 'video' ? 'video' : 'file', waitingFile.file)
      }
    },
  },
}
